import LogLevel from 'loglevel'
LogLevel.setDefaultLevel(process.env.VUE_APP_LOG_LEVEL)

// Vue plugin
export default {
  install: function (Vue) {
    Vue.prototype.$log = LogLevel
  },
  name: 'LogLevel',
}

// LogLevel に定義されているログレベル文字列
const definedLevels = [...Object.keys(LogLevel.levels)].map((l) =>
  l.toLowerCase()
)
/**
 * ログレベルを丸める
 * @param {number|string} value ログレベル
 * @returns {number|string} 丸められたログレベル 不正な場合は undefined
 */
const roundLevel = (value) => {
  if (typeof value === 'number') {
    // 0〜5の範囲外は端値に頭打ちする
    if (value < 0) {
      return 0
    } else if (value > 5) {
      return 5
    } else {
      return Math.floor(value)
    }
  } else if (typeof value === 'string') {
    if (definedLevels.includes(value.toLowerCase())) {
      return value.toLowerCase()
    } else {
      return undefined
    }
  } else {
    return undefined
  }
}

// グローバルオブジェクトに inject する用のログレベル設定オブジェクト
export const globalLog = {
  get level() {
    return LogLevel.getLevel()
  },
  set level(value) {
    const result = roundLevel(value)
    if (result === undefined) {
      throw new Error(`${value} is invalid log level!`)
    } else {
      LogLevel.setLevel(result)
    }
  },
}
